export const RESET_STATE = "RESET_STATE";
export const RESET_STATE_WITHOUT_AUTH = "RESET_STATE_WITHOUT_AUTH";
